import React, { Component } from 'react';
import { DropdownToggle, DropdownMenu, DropdownItem, Dropdown} from 'reactstrap';

// this component displays an array in the format: options = [{key: "key", value: "value"}, {key: "key", value: "value"} ]

class EirDropdownList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdownOpen: false,
      selectedOption: null
    };
  }

  toggle = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  };

  select = (selectedOption) => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
      selectedOption: selectedOption
    }, () => { 
      if (this.props.onClick) {
        this.props.onClick(selectedOption);
      }
    });
  };

  render() {
    return (
      <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
        
        <DropdownToggle className="btn-sort-menu d-flex ">{this.props.title}<span className="sort-icon eir-icon icon-arrowdown--black" /></DropdownToggle>

        <div className="device-sort-value">
          {this.state.selectedOption == null ? (this.props.initialOption ? this.props.initialOption.value : this.props.options[0].value) : this.state.selectedOption.value}
        </div>

        <DropdownMenu>

          {this.props.options.map((option, index) => (
            <DropdownItem key={index} onClick={() => { this.select(option); }}>
              {option.value}
            </DropdownItem>
          ))}

        </DropdownMenu>

      </Dropdown>
    );
  }
}

export default EirDropdownList;
